import { getFirestore, doc, collection, query, where, addDoc, getDoc, getDocs, updateDoc, setDoc, onSnapshot, deleteDoc, documentId, deleteField } from "firebase/firestore"
import { cleanOffersReferences } from "@/assets/functions/assetCleanup.js"
let db = getFirestore()

let collectionName = "boosters"

function docToInstance(document) {
	let data = document.data()
	return data ? new Booster(
		document.id,
		data.name,
		data.image,
		data.size,
		data.collection,
		data.price,
		data.canBuy,
		data.targetCollections || (data.collection ? [data.collection] : []),
		data.targetExtensions || [],
		data.isFull === true
	) : null
}

class Booster {
	constructor(id, name, image, size, collection, price, canBuy, targetCollections = [], targetExtensions = [], isFull = false) {
		this.id = id
		this.name = name
		this.image = image
		this.size = size
		this.collection = collection
		this.price = price
		this.canBuy = canBuy
		this.targetCollections = targetCollections
		this.targetExtensions = targetExtensions

		/**
		 * Booster Full : toute la collection, extensions comprises, un
		 * exemplaire de chaque carte en variante classique, sans tirage.
		 *
		 * FAUX PAR DÉFAUT, et c'est aussi ce que vaut un booster écrit avant que
		 * le champ n'existe : tous les anciens boosters restent des boosters
		 * ordinaires, sans migration.
		 *
		 * `size` reste écrit pour un booster Full, mais ce n'est plus un réglage :
		 * c'est le compte des cartes au dernier enregistrement, que la boutique
		 * affiche. Ce qui est réellement distribué est recompté à l'ouverture —
		 * voir `assets/functions/fullBooster.js`.
		 */
		this.isFull = isFull === true
	}

	static initOne(name = "") {
		let id = Booster.createId(name)
		const newBooster = new Booster(id, name, "", 5, "", 100, false, [], [], false)
		return newBooster
	}

	static createId(name) {
		let id = name
			.replace(/[^a-zA-Z0-9 ]/g, "")
			.replace(/ /g, "-")
			.toLowerCase()
			.replace(/-+/g, "-")
			.replace(/^-|-$/g, "")
		return id
	}

	static async getAll() {
		const documents = await getDocs(collection(db, collectionName))
		return documents.docs.map(docToInstance)
	}

	static async getById(id) {
		const document = await getDoc(doc(db, collectionName, id))
		return docToInstance(document)
	}

	static async getByName(name) {
		const q = query(collection(db, collectionName), where("name", "==", name))
		const documents = await getDocs(q)
		return documents.docs.map(docToInstance)
	}

	static async listenAll(callback) {
		return onSnapshot(collection(db, collectionName), (snapshot) => {
			const list = []
			snapshot.forEach((doc) => {
				list.push(docToInstance(doc))
			})
			callback(list)
		})
	}

	static async listenById(id, callback) {
		return onSnapshot(doc(db, collectionName, id), (snapshot) => {
			callback(docToInstance(snapshot))
		})
	}

	static async listenByName(name, callback) {
		const q = query(collection(db, collectionName), where("name", "==", name))
		return onSnapshot(q, (snapshot) => {
			const list = []
			snapshot.forEach((doc) => {
				list.push(docToInstance(doc))
			})
			callback(list)
		})
	}

	static buildImageUrl(imageName) {
		if (!imageName) return '';
		return `https://firebasestorage.googleapis.com/v0/b/tcg-21.firebasestorage.app/o/boosters%2F${encodeURIComponent(imageName)}?alt=media`;
	}

	async save() {
		const new_doc = {
			name: this.name,
			image: this.image,
			size: this.size,
			collection: this.collection,
			price: this.price,
			canBuy: this.canBuy,
			targetCollections: Array.isArray(this.targetCollections) ? this.targetCollections : (this.collection ? [this.collection] : []),
			targetExtensions: Array.isArray(this.targetExtensions) ? this.targetExtensions : [],
			isFull: this.isFull === true,
		}

		if (this.id) {
			await setDoc(doc(db, collectionName, this.id), new_doc)
		} else {
			this.id = Booster.createId(this.name)
			await setDoc(doc(db, collectionName, this.id), new_doc)
		}
		return true
	}

	async delete() {
		if (this.id) {
			const profilesSnapshot = await getDocs(collection(db, "profiles"))
			const updatePromises = []

			profilesSnapshot.forEach((profileDoc) => {
				const profileData = profileDoc.data()
				if (profileData.boosters && profileData.boosters[this.id]) {
					const updateData = {}
					updateData[`boosters.${this.id}`] = deleteField()
					updatePromises.push(updateDoc(profileDoc.ref, updateData))
				}
			})

			await Promise.all(updatePromises)

			// Cascade : retire le booster des offres (codes/générateurs).
			await cleanOffersReferences({ boosterIds: [this.id] })

			await deleteDoc(doc(db, collectionName, this.id))
		}
		return true
	}
}

export default Booster
